"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificArticlesUtil = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
/**
 * Provides utility functions for `SpecificArticles`
 */
class SpecificArticlesUtil {
    /**
     * filters given KetteJsons using OR.
     */
    static filterKetten(args) {
        const { specificArticles, ketteJsons } = args;
        if (!specificArticles.ketteArtNrParts.length &&
            !specificArticles.ketteEchainSystem.length &&
            !specificArticles.ketteSerieKuerzel.length) {
            return [];
        }
        let specificKetteJsons = [];
        specificArticles.ketteEchainSystem.forEach((echainSystem) => (specificKetteJsons = specificKetteJsons.concat(echain_shared_articles_1.KetteJsonUtil.filterByEchainSystem(ketteJsons, echainSystem))));
        specificArticles.ketteSerieKuerzel.forEach((kuerzel) => (specificKetteJsons = specificKetteJsons.concat(echain_shared_articles_1.KetteJsonUtil.filterBySerieKuerzel(ketteJsons, kuerzel))));
        specificArticles.ketteArtNrParts.forEach((part) => (specificKetteJsons = specificKetteJsons.concat(echain_shared_articles_1.KetteJsonUtil.filterByStartingArtNrPart(ketteJsons, part))));
        return specificKetteJsons;
    }
    /**
     * filters given KetteJsons using OR.
     */
    static filterEspools({ specificArticles, espoolJsonArray, }) {
        if (!specificArticles.ketteArtNrParts.length &&
            !specificArticles.ketteEchainSystem.length &&
            !specificArticles.ketteSerieKuerzel.length) {
            return [];
        }
        let specificEspoolJsons = [];
        const hasEspoolSystem = specificArticles.ketteEchainSystem.some((echainsystem) => echainsystem === 'Espool');
        if (hasEspoolSystem) {
            specificEspoolJsons = specificEspoolJsons.concat(espoolJsonArray);
        }
        specificArticles.ketteSerieKuerzel.forEach((kuerzel) => espoolJsonArray.forEach((espoolJson) => {
            var _a, _b;
            if ((((_a = espoolJson.SerieKuerzel) === null || _a === void 0 ? void 0 : _a.Metric) === kuerzel || ((_b = espoolJson.SerieKuerzel) === null || _b === void 0 ? void 0 : _b.Imperial) === kuerzel) &&
                !specificEspoolJsons.includes(espoolJson)) {
                specificEspoolJsons.push(espoolJson);
            }
        }));
        specificArticles.ketteArtNrParts.forEach((part) => {
            const matchedArticle = espoolJsonArray.filter((espoolJson) => {
                var _a;
                return Boolean((_a = echain_shared_i18n_1.LocaleService.getArtNr(espoolJson.ArtNr)) === null || _a === void 0 ? void 0 : _a.startsWith(part));
            });
            specificEspoolJsons = specificEspoolJsons.concat(matchedArticle);
        });
        return specificEspoolJsons;
    }
}
exports.SpecificArticlesUtil = SpecificArticlesUtil;
SpecificArticlesUtil.className = 'SpecificArticlesUtil';
//# sourceMappingURL=SpecificArticlesUtil.js.map